import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Pagination from "@mui/material/Pagination";

import { Modal, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import CustomSearchBar from "components/CustomSearchBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft, faEye } from "@fortawesome/free-solid-svg-icons";
import { selectCurrentUser } from "features/auth/authSlice";
import { Tag } from "antd";

import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import {
  CheckCircleOutlined,
  FileTextOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { useGetCrmInsuranceLeadsQuery } from "features/Insurance/InsuranceApiSlice";

import {
  useGetStatesQuery,
  useGetDistrictByStateQuery,
} from "services/locationApiSlice";

import Select from "react-select";
import * as XLSX from "xlsx";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { store } from "app/store";
import { API_URL } from "app/config";
import axios from "axios";
import { ClaimDetailView } from "./ClaimDetailView";
// import CattleClaimsMap from "./CattleClaimsMap";
import { InsuranceTaskDownload } from "./InsuranceTaskDownload";
import { InsuranceClaimsDownloadTask } from "./InsuranceClaimsDownloadTask";

const InsuranceClaims = () => {
  const currentUser = useSelector(selectCurrentUser);
  const [searchKey, setSearchKey] = useState("");
  const [stateId, setStateId] = useState("");
  const [districtId, setDistrictId] = useState("");
  const [blockId, setBlockId] = useState("");
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  // const [blockName, setBlockName] = useState("");

  const [statusName, setStatusName] = useState("");

  const { data: getStates } = useGetStatesQuery();
  const { data: dataDistrict } = useGetDistrictByStateQuery(stateId, {
    skip: !stateId,
  });
  // const { data: dataBlock } = useGetBlockByDistrictQuery(districtId, {
  //   skip: !districtId,
  // });
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  // const [blockList, setBlockList] = useState([]);
  const [loadingStateOptions, setloadingStateOptions] = useState(true);
  const [loadingDistrictOptions, setloadingDistrictOptions] = useState(false);
  const [users, setUsers] = useState([]);
  const [showWidth, setWidth] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    pageCount: 0,
    perPage: 100,
  });
  const [getDataId, setLeadId] = useState();
  const RoleAcessParams = currentUser.groups;
  const [templateDownload, setTemplateDownload] = useState(false);

  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [editOpen, EditingIsOpen] = useState(false);
  const queryParameters = React.useMemo(
    () => ({
      page: pagination.page,
      perPage: pagination.perPage,
      searchKey: debouncedSearch || "",
      selectedProduct: "Cattle_Claims",
      stateCode: stateId,
      districtCode: districtId,
      blockCode: blockId,
      statusName: statusName,
      statusIncludes: "",
    }),
    [
      pagination.page,
      pagination.perPage,
      debouncedSearch,
      stateId,
      districtId,
      blockId,
      statusName,
    ]
  );
  const { data, isLoading, isFetching, refetch } = useGetCrmInsuranceLeadsQuery(
    queryParameters
  );

  const [LeadsDataHalf, setLeadsDataHalf] = useState([]);
  const [loadingLeads, setLoadingLeads] = useState(false);
  const [serviceDetails, setServiceDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [details, setDetailsModal] = useState(false);

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const [showDownload, setDownloadLoading] = useState(false);
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "38px",
      height: "38px",
      borderRadius: "8px",
      fontSize: "13px",
      padding: "0 2px",

      transition: "all 0.2s ease",

      alignItems: "center",
    }),

    valueContainer: (provided) => ({
      ...provided,
      padding: "0 8px",
      display: "flex",
      alignItems: "center",
      height: "38px",
    }),

    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
      height: "auto",
    }),

    indicatorsContainer: (provided) => ({
      ...provided,
      height: "38px",
    }),

    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: "6px",
      transition: "color 0.2s ease",
    }),

    clearIndicator: (provided) => ({
      ...provided,
      padding: "6px",
      color: "#9ca3af",
    }),

    menu: (provided) => ({
      ...provided,
      borderRadius: "8px",
      marginTop: 4,
      // boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      fontSize: "13px",
      zIndex: 5,
    }),

    option: (provided, state) => ({
      ...provided,
      fontSize: "13px",
      padding: "8px 10px",

      cursor: "pointer",
    }),

    placeholder: (provided) => ({
      ...provided,
      color: "#9ca3af",
      marginLeft: 2,
    }),

    singleValue: (provided) => ({
      ...provided,
      color: "#111827",
      marginLeft: 2,
      lineHeight: "1",
    }),
  };

  useEffect(() => {
    const dataFromApi = data?.data ? data?.data?.results : [];
    const currentPage = data?.data?.current_page || pagination.page;
    const totalPages = data?.data?.pages || pagination.pageCount;
    const perPageFromApi = data?.data?.per_page || pagination.perPage;
    setUsers(dataFromApi);
    setPagination((prev) => {
      if (
        prev.page !== currentPage ||
        prev.pageCount !== totalPages ||
        prev.perPage !== perPageFromApi
      ) {
        return {
          page: currentPage,
          pageCount: totalPages,
          perPage: perPageFromApi,
        };
      }
      return prev;
    });

    if (getStates !== undefined) {
      setStateList(getStates?.data?.results);
      setloadingStateOptions(false);
    }
  }, [data, getStates]);

  const refetchLeadsData = async (id) => {
    const state = store.getState();
    setLoading(true);
    try {
      const getLeadsData = await axios.get(
        `${API_URL}/api/v1/crm/leads/${id}`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (getLeadsData?.data) {
        setLeadsDataHalf(getLeadsData?.data?.data);
        setLoading(false);
        let finalDataBanking = getLeadsData?.data?.data?.lead_details?.find(
          (item) => item.service_name === "Insurance"
        );
        setServiceDetails(finalDataBanking?.service_details);
      }
    } catch (error) {
      console.error("Error fetching farmer data:", error);
      throw error;
    }
  };

  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .ant-empty-img-1": {
      fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
      fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
    },
  }));

  const CustomNoRowsOverlay = () => {
    return (
      <StyledGridOverlay>
        <svg height="100" viewBox="0 0 184 152" focusable="false">
          <g fill="none" fillRule="evenodd">
            <g transform="translate(24 31.67)">
              <ellipse
                className="ant-empty-img-5"
                cx="67.797"
                cy="106.89"
                rx="67.797"
                ry="12.668"
              />
              <path
                className="ant-empty-img-1"
                d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
              />
              <path
                className="ant-empty-img-2"
                d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
              />
              <path
                className="ant-empty-img-3"
                d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
              />
            </g>
            <path
              className="ant-empty-img-3"
              d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
            />
            <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
              <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
              <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
            </g>
          </g>
        </svg>
        <Box sx={{ mt: 1 }}>No Records to Display</Box>
      </StyledGridOverlay>
    );
  };

  const handlePerPageRecords = (e) => {
    setPagination({ ...pagination, ...{ perPage: e.target.value } });
  };

  const CustomPagination = () => {
    return (
      <Box display="flex" alignItems="center" gap={2}>
        <select
          name="pages"
          value={pagination.perPage} // ✅ controlled value
          onChange={handlePerPageRecords}
          style={{ padding: "4px 8px", borderRadius: "7px" }}
        >
          <option value={10}>10</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>

        <Pagination
          color="primary"
          count={pagination?.pageCount}
          page={pagination?.page}
          onChange={(event, value) => {
            setPagination({
              ...pagination,
              page: value,
            });
            setWidth(false);
          }}
          variant="outlined"
          shape="rounded"
        />
      </Box>
    );
  };

  const handleModalOpen = (item) => {
    setDetailsModal(true);
    setLeadId(item.id);
    refetchLeadsData(item.id);
  };

  //  const formatDateTime = (dateString) => {
  //   if (!dateString) return "";

  //   let date;

  //   if (dateString.includes("T")) {
  //     date = new Date(dateString);
  //   }
  //   else {
  //     const parts = dateString.split("/");
  //     if (parts.length === 3) {
  //       const [day, month, year] = parts;
  //       date = new Date(`${year}-${month}-${day}T00:00:00`);
  //     }
  //   }

  //   if (!date || isNaN(date.getTime())) return "";

  //   const day = date.getDate();
  //   const month = date.toLocaleString("en-IN", { month: "long" });
  //   const year = date.getFullYear();

  //   const time = date
  //     .toLocaleTimeString("en-IN", {
  //       hour: "2-digit",
  //       minute: "2-digit",
  //       hour12: true,
  //     })
  //     .replace(" ", "")
  //     .toUpperCase();

  //   return `${day} ${month} ${year} , ${time}`;
  // };
  const formatDateTime = (dateString) => {
    if (!dateString) return "";

    let date;

    if (dateString.includes("T")) {
      date = new Date(dateString);
    }

    else {
      const [datePart, timePart] = dateString.split(" ");
      const parts = datePart?.split("/");

      if (parts?.length === 3) {
        const [day, month, year] = parts;

        const time = timePart ? `${timePart}:00` : "00:00:00";

        date = new Date(`${year}-${month}-${day}T${time}`);
      }
    }

    if (!date || isNaN(date.getTime())) return "";

    const day = date.getDate();
    const month = date.toLocaleString("en-IN", { month: "long" });
    const year = date.getFullYear();

    const time = date
      .toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .replace(" ", "")
      .toUpperCase();

    return `${day} ${month} ${year} , ${time}`;
  };

  const columns = [
    {
      field: "action",
      headerName: "Action",
      width: 50,
      renderCell: ({ row }) => (
        <FontAwesomeIcon
          icon={faEye}
          style={{
            color: "orange",
            fontSize: "12px",
            cursor: "pointer",
            marginLeft: "10px",
          }}
          onClick={() => handleModalOpen(row)}
        />
      ),
    },
    {
      field: "application_number",
      headerName: "Reference No.",
      width: 200,
      renderCell: ({ row }) => {
        const tag = row?.lead_details?.[0]?.application_id;

        return <div>{tag}</div>;
      },
    },

    {
      field: "tag_number",
      headerName: "Cattle Tag No",
      width: 150,
      renderCell: ({ row }) => {
        const tag =
          row?.lead_details?.[0]?.service_details?.incident_details
            ?.cattle_tag_number;

        return (
          <div
            style={{
              textAlign: "center",
              fontSize: "14px",
              color: "steelblue",
              fontWeight: 500,
            }}
          >
            {tag}
          </div>
        );
      },
    },

    {
      field: "incident_date_time",
      headerName: "Occurrence DateTime",
      width: 210,
      renderCell: ({ row }) =>
        formatDateTime(
          row?.lead_details?.[0]?.service_details?.incident_details
            ?.incident_date_time
        ),
    },

    {
      field: "created_at",
      headerName: "Reported DateTime",
      width: 210,
      renderCell: ({ row }) => formatDateTime(row?.created_at),
    },
    {
      field: "cattle_type",
      headerName: "Cattle Type",
      width: 150,
      renderCell: ({ row }) => {
        const tag =
          row?.lead_details?.[0]?.service_details?.incident_details
            ?.cattle_type;

        return <div>{tag}</div>;
      },
    },
    {
      field: "cause_loss",
      headerName: "Cause Of Loss",
      width: 150,
      renderCell: ({ row }) => {
        const tag =
          row?.lead_details?.[0]?.service_details?.incident_details
            ?.cause_of_loss;

        return (
          <div
            style={{
              textAlign: "center",
              fontSize: "14px",
              color: "steelblue",
              fontWeight: 500,
            }}
          >
            {tag}
          </div>
        );
      },
    },

    {
      field: "current_status",
      headerName: "Current Status",
      width: 240,
      renderCell: ({ row }) => {
        const statusConfig = {
          "Claim Approved": {
            color: "green",
            icon: <FileTextOutlined />,
          },
          "Claim Settled": { color: "gold", icon: <CheckCircleOutlined /> },
          "Claim Declined": { color: "error", icon: <WarningOutlined /> },
          "Claim Rejected": { color: "error", icon: <WarningOutlined /> },
          "Claim Accepted": { color: "volcano", icon: <FileTextOutlined /> },
        };

        const { color, icon } = statusConfig[row.current_status] || {
          color: "geekblue",
          icon: <FileTextOutlined />,
        };

        return (
          <Tag
            bordered={false}
            color={color}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "3px 9px",
              fontSize: "13px",
              fontWeight: "500",
              borderRadius: "6px",
            }}
          >
            {icon}
            <span>
              {row.current_status
                ?.toLowerCase()
                .replace(/_/g, " ")
                .replace(/\b\w/g, (char) => char.toUpperCase())}
            </span>
          </Tag>
        );
      },
    },

    {
      field: "full_name",
      headerName: "Farmer Name",
      width: 180,
    },

    {
      field: "phone_number",
      headerName: "Phone No.",
      width: 150,
      renderCell: ({ row }) => (
        <div style={{ fontSize: "14px", color: "#555", fontWeight: 500 }}>
          {row.phone_number}
        </div>
      ),
    },

    {
      field: "lead_source",
      headerName: "Lead Source",
      width: 150,
    },
  ];

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchKey.trim() ? searchKey : "");
    }, 500);

    return () => clearTimeout(handler);
  }, [searchKey]);
  const handleChangeSearch = (message) => {
    setPagination({ page: 1, pageCount: 0, perPage: 100 });

    setSearchKey(message);
  };

  const ReloadApplication = () => {
    setLoadingLeads(true);
    setTimeout(() => {
      refetch();
      setLoadingLeads(false);
    }, 1000);
  };
  const ReloadApplication2 = () => {
    refetchLeadsData(getDataId);
  };

  const handleStateOptions = () => {
    let responseAgentArray = [];
    stateList.map((state) => {
      responseAgentArray.push({
        value: state.state_code,
        label: state.state_name,
        ConditionName: "state",
      });
    });
    return responseAgentArray;
  };
  const handleDistrictOptions = () => {
    let responseAgentArray = [];
    districtList.map((district) => {
      responseAgentArray.push({
        value: district.district_code,
        label: district.district_name,
        ConditionName: "district",
      });
    });
    return responseAgentArray;
  };

  const onLocationChange = (event) => {
    setPagination({ page: 1, pageCount: 0, perPage: 100 });

    if (event.ConditionName == "state") {
      setBlockId("");
      setDistrictName("");
      setDistrictId("");

      setStateId(event.value);
      setStateName(event.label);
    }
    if (event.ConditionName == "district") {
      setDistrictId(event.value);
      setDistrictName(event.label);
    }
  };

  useEffect(() => {
    if (dataDistrict != undefined) {
      setDistrictList(dataDistrict?.data?.results);
      setloadingDistrictOptions(false);
    }
  }, [dataDistrict]);
  // useEffect(() => {
  //   if (dataBlock != undefined) {
  //     setBlockList(dataBlock?.data?.results);
  //   }
  // }, [dataBlock]);
  const handleStatusChange = (selectedOption) => {
    if (selectedOption) {
      setStatusName(selectedOption.value);
    } else {
      setStatusName("");
    }
    setPagination({ page: 1, pageCount: 0, perPage: 100 });
  };

  const downloadExcel = async () => {
    setDownloadLoading(true);
    try {
      const queryParameters = {
        page: 1,
        per_page: 1000,
        searchKey:
          debouncedSearch || (RoleAcessParams?.includes("INSURER") ? "" : ""),
        product_name: "Cattle_Claims",
        stateCode: stateId,
        districtCode: districtId,
        blockCode: blockId,
        statusName: statusName,
        statusIncludes: "",
      };

      const params = new URLSearchParams(queryParameters).toString();
      const state = store.getState();

      const url = `${API_URL}/api/v1/crm/insurance/leads?${params}`;
      const response = await fetch(url, {
        headers: {
          authorization: `Bearer ${state.auth.accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch data: ${response.statusText}`);
      }

      const farmers = await response.json();
      const headers = [
        "Reference Number",
        "Cattle Tag Number",
        "Occurance Date",
        "Reported Date",
        "Cattle Type",
        "Cause Of Loss",
        "Current Status",
        "Farmer Name",
        "Phone Number",
        "Lead Source",
      ];
      const rows = farmers?.data?.results?.map((user) => {
        const baseRow = {
          "Reference Number": user.lead_details?.[0]?.application_id,
          "Cattle Tag Number":
            user.lead_details?.[0]?.service_details?.incident_details
              ?.cattle_tag_number || "",

          "Occurance Date": formatDateTime(
            user.lead_details?.[0]?.service_details?.incident_details
              ?.incident_date_time
          ),

          "Reported Date": formatDateTime(user.created_at),
          "Cattle Type":
            user?.lead_details?.[0]?.service_details?.incident_details
              ?.cattle_type,
          "Cause Of Loss":
            user.lead_details?.[0]?.service_details?.incident_details
              ?.cause_of_loss || "",
          "Current Status": user.current_status || "",
          "Farmer Name": user.full_name || "",
          "Phone Number": user.phone_number || "",
          "Lead Source": user.lead_source || "",
        };

        return baseRow;
      });

      const worksheet = XLSX.utils.json_to_sheet(rows, { header: headers });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");

      XLSX.writeFile(workbook, "LeadsData.xlsx");
    } catch (error) {
      console.error("Excel download failed:", error.message);
    } finally {
      setDownloadLoading(false);
    }
  };

  const [activeTab, setActiveTab] = useState("table");

  return (
    <div>
      <div className="row mt-3">
        <div className={showWidth ? "col-md-4" : "col-md-12"}>
          <Card>
            <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
              <div className="d-flex align-items-center gap-3">
                {activeTab === "table" && (
                  <>
                    <CustomSearchBar sendSearchFunction={handleChangeSearch} />
                    <span className="fw-semibold text-success">
                      Total Leads: {data?.data?.total || 0}
                    </span>
                  </>
                )}
              </div>

              {/* <div className="d-flex gap-2">
                <div
                  className={`chipTab ${activeTab === "table" ? "active" : ""}`}
                  onClick={() => setActiveTab("table")}
                >
                  <FontAwesomeIcon icon={faTable} className="me-1" />
                  Table View
                </div>
                <div
                  className={`chipTab ${activeTab === "map" ? "active" : ""}`}
                  onClick={() => setActiveTab("map")}
                >
                  <FontAwesomeIcon icon={faMapMarkedAlt} className="me-1" />
                  Map View
                </div>
              </div> */}
            </div>

            {/* {activeTab === "map" ? (
              <div className="col-md-12">
                <div className="p-3">
                  <CattleClaimsMap cattleDetails={users} />
                </div>
              </div>
            ) : ( */}
            <>
              <CardHeader>
                <Row className="align-items-center mx-2 mt-2">
                  <Col lg="5" className="d-flex gap-2 ">
                    <Col sm="4" className="mb-2 position-relative">
                      <Select
                        menuPlacement="auto"
                        options={handleStateOptions()}
                        placeholder={stateId === "" ? "State" : stateName}
                        value={
                          stateId === ""
                            ? null
                            : { value: stateId, label: stateName }
                        }
                        onChange={onLocationChange}
                        styles={customStyles}
                        isLoading={loadingStateOptions}
                      />
                      {stateId && (
                        <span
                          className="clear-icon"
                          onClick={() => {
                            setStateId("");
                            setStateName("");
                          }}
                          style={{
                            position: "absolute",
                            top: "50%",
                            right: "40px",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "gray",
                            fontSize: "12px",
                            zIndex: 1000,
                          }}
                        >
                          ✕
                        </span>
                      )}
                    </Col>

                    <Col sm="4" className="mb-2 position-relative">
                      <Select
                        menuPlacement="auto"
                        options={handleDistrictOptions()}
                        placeholder={
                          districtName === "" ? "District" : districtName
                        }
                        value={
                          districtName === ""
                            ? null
                            : { value: districtId, label: districtName }
                        }
                        onChange={onLocationChange}
                        styles={customStyles}
                        isLoading={loadingDistrictOptions}
                      />
                      {districtName && (
                        <span
                          className="clear-icon"
                          onClick={() => {
                            setDistrictId("");
                            setDistrictName("");
                          }}
                          style={{
                            position: "absolute",
                            top: "50%",
                            right: "40px",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "gray",
                            fontSize: "12px",
                            zIndex: 1000,
                          }}
                        >
                          ✕
                        </span>
                      )}
                    </Col>

                    <Col sm="4" className="mb-2 position-relative">
                      <Select
                        menuPlacement="auto"
                        options={[
                          {
                            value: "Lead Generated",
                            label: "Lead Generated",
                          },

                          {
                            value: "Claim Accepted",
                            label: "Claim Accepted",
                          },
                          {
                            value: "Claim Declined",
                            label: "Claim Declined",
                          },
                          {
                            value: "Claim Approved",
                            label: "Claim Approved",
                          },

                          {
                            value: "Claim Rejected",
                            label: "Claim Rejected",
                          },
                          {
                            value: "Claim Settled",
                            label: "Claim Settled",
                          },
                        ]}
                        placeholder="Status"
                        value={
                          statusName
                            ? { value: statusName, label: statusName }
                            : null
                        }
                        onChange={handleStatusChange}
                        styles={customStyles}
                      />
                      {statusName && (
                        <span
                          className="clear-icon"
                          onClick={() => {
                            setStatusName("");
                          }}
                          style={{
                            position: "absolute",
                            top: "50%",
                            right: "40px",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "gray",
                            fontSize: "12px", // Make it larger if needed
                            zIndex: 1000, // Ensure it stays on top of other elements
                          }}
                        >
                          ✕
                        </span>
                      )}
                    </Col>
                  </Col>

                  <Col lg="7" className="d-flex justify-content-end gap-2">
                    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                      <DropdownToggle
                        caret
                        className=""
                        size="sm"
                        style={{ backgroundColor: "#43b620" }}
                      >
                        Downloads&nbsp;
                        <i className="mdi mdi-download custom-btn-fs fs-6"></i>{" "}
                        {showDownload && <Spinner size="sm" />}
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem
                          onClick={downloadExcel}
                          className="dropdown-hover-item"
                        >
                          Download CSV
                        </DropdownItem>
                        <DropdownItem
                          onClick={(e) => setTemplateDownload(true)}
                          className="dropdown-hover-item"
                        >
                          Download Documents
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>

                    <Button
                      className="bg-transparent text-black"
                      style={{
                        border: "1px solid #829999",
                        color: "#343737",
                        marginTop: "0",
                      }}
                      size="sm"
                      onClick={ReloadApplication}
                    >
                      <FontAwesomeIcon icon={faRotateLeft} />
                    </Button>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody className="p-3">
                <>
                  {!loadingLeads ? (
                    <>
                      <div className="row">
                        <div className="col-md-10  offset-md-1 float-right mt-2"></div>
                      </div>
                      <Box
                        className="mt-lg-0 mt-2"
                        sx={{
                          position: "relative",
                          ...(isLoading && { height: "50vh" }),
                        }}
                      >
                        <DataGrid
                          rows={users}
                          columns={columns}
                          initialState={{
                            pagination: {
                              paginationModel: {
                                pageSize: 100,
                              },
                            },
                          }}
                          SelectionMode="Single"
                          SelectionUnit="Cell"
                          loading={isLoading || isFetching}
                          components={{
                            Pagination: CustomPagination,
                            NoRowsOverlay: CustomNoRowsOverlay,
                          }}
                        />
                      </Box>
                    </>
                  ) : (
                    <div className="text-center align-middle mt-5 pb-4">
                      {" "}
                      <Spinner
                        animation="border"
                        size="lg"
                        className="text-center align-middle"
                      />
                    </div>
                  )}
                </>
              </CardBody>
            </>
            {/* )} */}
          </Card>
        </div>

        <Modal
          show={details}
          onHide={() => {
            setDetailsModal(false);
            EditingIsOpen(false);
          }}
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title
              as="div"
              className="fw-bold d-flex justify-content-between align-items-center"
              style={{ width: "100%" }}
            >
              <span style={{ color: "#343737" }}>Lead Information</span>

              <div>
                {!editOpen && (
                  <Button
                    className="bg-transparent text-black"
                    style={{
                      border: "1px solid #829999",
                      color: "#343737",
                    }}
                    size="sm"
                    onClick={ReloadApplication2}
                  >
                    <FontAwesomeIcon icon={faRotateLeft} />
                  </Button>
                )}
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-2" style={{ backgroundColor: "#f9f9f9" }}>
            <div>
              {loading ? (
                <Skeleton count={15} />
              ) : LeadsDataHalf ? (
                <ClaimDetailView
                  LeadsDataHalf={LeadsDataHalf}
                  refetchLeadsData={refetchLeadsData}
                  refetch={refetch}
                />
              ) : (
                <p style={{ color: "#999", textAlign: "center" }}>
                  No lead information available.
                </p>
              )}
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={templateDownload}
          onHide={() => setTemplateDownload(false)}
          size="xl"
        >
          <Modal.Header closeButton style={{ backgroundColor: "lightgrey" }}>
            <Modal.Title className="fw-bold">Download Report</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-2">
            <div className="mt-2 mx-2">
              <InsuranceClaimsDownloadTask />
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};
export default InsuranceClaims;
